import { render } from "./TelaSync.vue?vue&type=template&id=6593699c&scoped=true"
import script from "./TelaSync.vue?vue&type=script&lang=js"
export * from "./TelaSync.vue?vue&type=script&lang=js"

import "./TelaSync.vue?vue&type=style&index=0&id=6593699c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6593699c"]])

export default __exports__